

exports.__esModule = true;

require('uiUtils');

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _angular = require('angular');

var _squid = require('squid');

var _uiRouter = require('uiRouter');

var _logger = require('xo-beaver/dist/logger');

var _venmoModels = require('xo-third-party-components/src/venmo-models');

var _index = require('xo-models/src/fi/index');

require('xo-address-components/src/add-address/directive');

require('xo-page-components/src/aside-header/directive');

require('xo-ui-components/src/accessibility/directive');

require('xo-ui-components/src/error-tooltip/directive');

require('xo-form-components/src/select-shipping-country/directive');

require('xo-ui-components/src/dropdown/directive');

require('xo-ui-components/src/message/directive');

require('xo-form-components/src/phone/phoneInput/directive');

require('xo-form-components/src/emailInput/directive');

require('xo-form-components/src/name-input/directive');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

require('./style');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$VenmoInfoGather', {
    tag: 'venmo-info-gather',
    template: _template2['default'],

    props: {
        token: {
            type: 'var',
            optional: false
        },
        sidebar: {
            type: 'var',
            optional: false
        }
    },

    actions: {
        onSubmit: function onSubmit() {
            var _this = this;

            this.actions.clearFieldErrors();
            this.actions.validateAddress().then(function (validations) {
                var billing = validations[0],
                    shipping = validations[1];
                var _buyerInfo = _this.buyerInfo,
                    user = _buyerInfo.user,
                    billingAddress = _buyerInfo.billingAddress,
                    shippingAddress = _buyerInfo.shippingAddress,
                    shipToBilling = _buyerInfo.shipToBilling;


                if (shipToBilling && billing === 'success') {
                    // Add the address as Billing AND Shipping Address

                    var addVenmoSupplements = new _venmoModels.$VenmoSupplementaryInfo({
                        user: user,
                        billing: billingAddress,
                        shipToBilling: shipToBilling
                    });

                    addVenmoSupplements.save({
                        success: function success() {
                            _logger.$logger.info('checkout_fpti', {
                                from: 'VENMO_OT_BILLING',
                                to: 'process_billing'
                            });

                            // Need to re-run the last route now that contingency has been resolved
                            _uiRouter.$state.go('^', {}, { reload: true });
                        },
                        error: function error() {
                            _logger.$logger.info('checkout_fpti', {
                                from: 'VENMO_OT_BILLING',
                                to: 'process_billing',
                                int_error_desc: 'unable to save address',
                                error_source: 'hermesnodeweb'
                            });

                            _this.goto('checkout.login');
                        }
                    });
                } else if (billing === 'success' && shipping === 'success') {
                    // Add the addresses as Billing and Shipping accordingly and separatley
                    var _addVenmoSupplements = new _venmoModels.$VenmoSupplementaryInfo({
                        user: user,
                        billing: billingAddress,
                        shipping: shippingAddress,
                        shipToBilling: shipToBilling
                    });

                    _addVenmoSupplements.save({
                        success: function success() {
                            _logger.$logger.info('checkout_fpti', {
                                from: 'VENMO_OT_BILLING',
                                to: 'process_billing'
                            });

                            // Need to re-run the last route now that contingency has been resolved
                            _uiRouter.$state.go('^', {}, { reload: true });
                        },
                        error: function error() {
                            _logger.$logger.info('checkout_fpti', {
                                from: 'VENMO_OT_BILLING',
                                to: 'process_billing',
                                int_error_desc: 'unable to save address',
                                error_source: 'hermesnodeweb'
                            });

                            _this.goto('checkout.login');
                        }
                    });
                } else {
                    // nothing to do here.. validations need to be resolved.
                }
            });
        },
        clearFieldErrors: function clearFieldErrors() {
            (0, _jquery2['default'])('#venmoInfoCollect .backendError').removeAttr('aria-invalid').removeClass('backendError');
        },
        validateAddress: function validateAddress() {
            var _this2 = this;

            var _buyerInfo2 = this.buyerInfo,
                billingAddress = _buyerInfo2.billingAddress,
                shippingAddress = _buyerInfo2.shippingAddress;

            var validationPromises = [];

            // create models
            var billingAddressValidate = new _index.$BillingAddressModel(billingAddress);

            var shippingAddressValidate = new _index.$BillingAddressModel(shippingAddress);

            // insert validation promises in array
            validationPromises.push(billingAddressValidate.save({
                success: function success(validateRes) {
                    return 'success';
                },
                validation: function validation(res) {
                    _this2.actions.handleValidation(res, '.billing');
                },
                error: function error(err) {
                    _logger.$logger.info('VENMO_BILLING_ADDRESS_VALIDATION', err);
                    _this2.goto('checkout.login', { venmoError: true });
                }
            }));

            // add the shipping promise if flag is NOT ship to billing address
            if (!this.buyerInfo.shipToBilling) {

                validationPromises.push(shippingAddressValidate.save({
                    success: function success(validateRes) {
                        return 'success';
                    },
                    validation: function validation(res) {
                        _this2.actions.handleValidation(res, '.shipping');
                    },
                    error: function error(err) {
                        _logger.$logger.info('VENMO_SHIPPING_ADDRESS_VALIDATION', err);
                        _this2.goto('checkout.login', { venmoError: true });
                    }
                }));
            }

            // resolve validation promises
            return _angular.$q.all(validationPromises);
        },
        handleValidation: function handleValidation(res, classIdentifier) {

            var $el = (0, _jquery2['default'])(this.$element);

            if (res && res.fields && res.fields.length) {
                res.fields.forEach(function (field) {
                    if (field.field) {
                        var $field = (0, _jquery2['default'])($el.find(classIdentifier + ' [name="\' + field.field + \'"]'));

                        if ($field.length === 0 && field.field === 'zip') {
                            $field = (0, _jquery2['default'])($el.find(classIdentifier + ' [ng-model="address.postal_code"], [ng-model="zipCode"]'));
                        }

                        $field.addClass('backendError');
                        $field.attr('aria-invalid', true);
                    }
                });
            }

            $el.find('form').find('.backendError, .ng-invalid').first().focus();
        }
    },

    lifecycle: {
        enter: function enter() {

            this.buyerInfo = {
                user: {},
                shippingAddress: {
                    country: _squid.$locale.country
                },
                billingAddress: {
                    country: _squid.$locale.country
                },
                shipToBilling: true // is our Billing Address also our Shipping Address?
            };
        }
    }
});


_angular.$q;

_squid.$Component;

_squid.$locale;

_uiRouter.$state;

_logger.$logger;

_venmoModels.$VenmoSupplementaryInfo;

_index.$BillingAddressModel;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-third-party-components/src/venmo-info-gather/directive.js
// module id = ../node_modules/xo-third-party-components/src/venmo-info-gather/directive.js
// module chunks = 0